import { type FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export type Mode = 'disabled' | 'statuses' | 'approvals';

export const IN_REVIEW_STATUS_ID = '1';
export const APPROVED_STATUS_ID = '2';
export const CHANGES_REQUESTED_STATUS_ID = '3';

// Shared support article for approvals across the content-state SpaceAdminConfig
// surfaces. Keep this as the single source of truth so the URL is not redefined
// per component.
export const APPROVALS_LEARN_MORE_URL =
	'https://support.atlassian.com/confluence-cloud/docs/request-and-manage-approvals-in-confluence/';

export type StatusAndApprovalsConfigProps = {
	spaceKey: string;
	flags: FlagsStateContainer;
};
